export const mapNumberToLetter = (target: number) =>
    (target + 9).toString(36).toUpperCase();
